// extracted by mini-css-extract-plugin
export default {"menuOpened":"style_menuOpened__EQpAc","menuClosed":"style_menuClosed__J07RW"};